import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { userManagement, userManagementBaseUrl } from '../endpoints';
// Define a service using a base URL and expected endpoints
export const familyOfficeMasterService = createApi({
    reducerPath: 'familyOfficeMasterService',
    baseQuery: fetchBaseQuery({ baseUrl: userManagementBaseUrl }),
    tagTypes: ['FamilyOffice'],
    endpoints: (builder) => ({
        getAllFamilyOfficeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeMasterController.getAllFamilyOfficeMaster}/${body.page}/${body.size}?orderBy=${body.orderBy}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getFamilyOfficeMasterById: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeMasterController.getFamilyOfficeMasterById}/${body.id}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        saveFamilyOfficeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeMasterController.saveFamilyOfficeMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        updateFamilyOfficeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeMasterController.updateFamilyOfficeMaster}/${body.id}`,
                    method: 'PUT',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
        deleteFamilyOfficeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeMasterController.deleteFamilyOfficeMaster}/${body.id}`,
                    method: 'DELETE',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        getAllFamilyOfficeMasterBySearch: builder.mutation({
            query(body) {
                console.log(body, "body");

                return {
                    url: `${userManagement.familyOfficeMasterController.getAllFamilyOfficeMasterBySearch}`,
                    method: "POST",
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                };
            },
        }),
        findAllFamilyOfficeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeMasterController.findAllFamilyOfficeMaster}`,
                    method: 'GET',
                    headers: { Authorization: `Bearer ${body.token}` },
                }
            }
        }),
        bulkSaveFamilyOfficeMaster: builder.mutation({
            query(body) {
                return {
                    url: `${userManagement.familyOfficeMasterController.bulkSaveFamilyOfficeMaster}`,
                    method: 'POST',
                    headers: { Authorization: `Bearer ${body.token}` },
                    body: body.payload,
                }
            }
        }),
    })
});
export const {
    useGetAllFamilyOfficeMasterMutation,
    useGetFamilyOfficeMasterByIdMutation,
    useSaveFamilyOfficeMasterMutation,
    useUpdateFamilyOfficeMasterMutation,
    useDeleteFamilyOfficeMasterMutation,
    useGetAllFamilyOfficeMasterBySearchMutation,
    useFindAllFamilyOfficeMasterMutation,
    useBulkSaveFamilyOfficeMasterMutation,
} = familyOfficeMasterService;